import { FC } from 'react';
import { SeoLinkType } from '@edikk-edikk/country-frontend';
import { Button, ButtonVariant } from '@edikk-edikk/country-layout-black';

type PropsType = {
  city: SeoLinkType;
};

const SeoBlockCity: FC<PropsType> = ({
  city,
}) => (
  <Button
    pill
    navLinkProps={{
      to: city.link.to,
      state: city.link.state,
      end: true,
      variant: ({ isActive }) => {
        if (isActive) {
          return ButtonVariant.white;
        }
        return ButtonVariant.outlineWhite;
      },
    }}
    dataAttributeList={{
      ...city.link.state.routerConfig,
    }}
  >
    {city.title}
  </Button>
);

export { SeoBlockCity };
